module.exports = __webpack_public_path__ + "img/rocking-chairs.011edffd.svg";